/* istanbul ignore file */

export enum BlockModuleState {
  EXPANDED = 'expanded',
  COLLAPSED = 'collapsed',
  SEMI = 'semi',
  // PREVIEW = 'preview',
}
